<script setup lang="ts">
import { useVoiceNotesWidget } from '@/composables/useVoiceNotesWidget'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { Mic, Maximize2, X } from 'lucide-vue-next'

const { isOpen, isMinimized, open, restore, close } = useVoiceNotesWidget()
</script>

<template>
  <!-- FAB (when not open and not minimized) -->
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    leave-active-class="transition-all duration-200 ease-in"
    enter-from-class="opacity-0 scale-75"
    enter-to-class="opacity-100 scale-100"
    leave-from-class="opacity-100 scale-100"
    leave-to-class="opacity-0 scale-75"
  >
    <TooltipProvider v-if="!isOpen && !isMinimized">
      <Tooltip>
        <TooltipTrigger as-child>
          <Button
            variant="default"
            size="icon"
            class="fixed bottom-36 right-4 z-[80] h-12 w-12 rounded-full shadow-lg"
            @click="open"
          >
            <Mic class="h-6 w-6" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left" :side-offset="8">
          <p class="text-sm">Notas de Voz</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </Transition>

  <!-- Minimized widget -->
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    leave-active-class="transition-all duration-200 ease-in"
    enter-from-class="opacity-0 translate-y-4 scale-95"
    enter-to-class="opacity-100 translate-y-0 scale-100"
    leave-from-class="opacity-100 translate-y-0 scale-100"
    leave-to-class="opacity-0 translate-y-4 scale-95"
  >
    <div
      v-if="isMinimized"
      class="fixed bottom-36 right-4 z-[90] bg-background border rounded-lg shadow-lg p-3 flex items-center gap-3 w-56"
    >
      <div class="flex-shrink-0 h-8 w-8 rounded bg-primary/10 flex items-center justify-center">
        <Mic class="h-4 w-4 text-primary" />
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-sm font-medium truncate">Notas de Voz</p>
        <p class="text-xs text-muted-foreground">Minimizado</p>
      </div>
      <div class="flex items-center gap-1 flex-shrink-0">
        <Button
          variant="ghost"
          size="icon"
          class="h-7 w-7"
          @click="restore"
          title="Restaurar"
        >
          <Maximize2 class="h-3.5 w-3.5" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          class="h-7 w-7 text-muted-foreground hover:text-destructive"
          @click="close"
          title="Cerrar"
        >
          <X class="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  </Transition>
</template>
